import {RestService} from "@/services/rest/RestService";
import {ContentPageRowEndpointsApi} from "@/api/pharma-cms-content-page";
import {
    ContentPageRowCreateRestDto,
    ContentPageRowRestDto,
    ContentVisibilityRuleForElementRestDto
} from "@/api/pharma-cms-content-page/models";
import {ContentPageRowRestDtoModel} from "@/models/ContentPageRowRestDtoModel";
import {MoveActionEnum} from "@/models/enum/MoveActionEnum";

export class ContentPageRowRestService extends RestService {

    private apiService: ContentPageRowEndpointsApi;

    protected constructor() {
        super();

        this.apiService = new ContentPageRowEndpointsApi(this.getDpAxiosV2Instance(), undefined, this.getConfig().cmsUrl);
    }

    public async getContentPageRowVisibilityRule(pageId: string, rowId: string): Promise<ContentVisibilityRuleForElementRestDto> {
        const response = await this.apiService.getContentPageRowVisibilityRule(pageId, rowId);

        return response.data;
    }

    public async updateContentPageRowVisibilityRule(visibilityRuleForElement: ContentVisibilityRuleForElementRestDto, pageId: string, rowId: string): Promise<void> {
        await this.apiService.updateContentPageRowVisibilityRule(visibilityRuleForElement, pageId, rowId);
    }

    public async getContentPageRow(pageId: string, rowId: string): Promise<ContentPageRowRestDto> {
        const response = await this.apiService.getContentPageRow(pageId, rowId);

        return response.data;
    }

    public async updateContentPageRow(row: ContentPageRowRestDto, pageId: string, rowId: string): Promise<void> {
        await this.apiService.updateContentPageRow(row, pageId, rowId);
    }

    public async createContentPageRow(pageId: string): Promise<void> {
        const contentPageRow = {
            target_position: {},
            row: ContentPageRowRestDtoModel.createWithDefaults(),
        } as ContentPageRowCreateRestDto;

        await this.apiService.createContentPageRow(contentPageRow, pageId);
    }

    public async copyContentPageRow(pageId: string, rowId: string): Promise<void> {
        await this.apiService.copyContentPageRow(pageId, rowId);
    }

    public async deleteContentPageRow(pageId: string, rowId: string): Promise<void> {
        await this.apiService.deleteContentPageRow(pageId, rowId);
    }

    public async moveContentPageRow(pageId: string, rowId: string, moveAction: MoveActionEnum): Promise<void> {
        switch (moveAction) {
            case MoveActionEnum.TOP:
                await this.apiService.moveContentPageRowToTop(pageId, rowId);
                break;
            case MoveActionEnum.BOTTOM:
                await this.apiService.moveContentPageRowToBottom(pageId, rowId);
                break;
            case MoveActionEnum.UP:
                await this.apiService.moveContentPageRowUp(pageId, rowId);
                break;
            case MoveActionEnum.DOWN:
                await this.apiService.moveContentPageRowDown(pageId, rowId);
                break;
            default:
                throw new Error('Unsupported moveAction to call ' + moveAction);
        }
    }
}
